import type { TypeWeeklyHoursAction } from 'types/actionPlan';
import { useTranslation } from 'react-i18next';
import { getShortCC } from 'utils/text';
import Text from '@ingka/text';
import SSRIcon from '@ingka/ssr-icon';
import arrowRight from '@ingka/ssr-icon/paths/arrow-right-small';
import classes from '../ActionTable.module.scss';

const WeeklyHoursAction = ({ action }:{ action: TypeWeeklyHoursAction }) => {
    const { t } = useTranslation();

    return (
        <div className={classes['details-changes']}>
            <div className={classes['details-changes-container']}>
                <Text
                    tagName="span"
                    textStyle="Heading.S"
                    data-testid="action-plan-weekly-hours-header"
                >
                    {t('WEEKLY_HOURS')}
                </Text>
                <Text data-testid="action-plan-weekly-hours-change">
                    {`${action.from} ${t('globals.labels.hours_abbreviated')}`}
                    <SSRIcon paths={arrowRight} />
                    {`${action.to} ${t('globals.labels.hours_abbreviated')}`}
                    <b>
                        {`(CC${getShortCC(action.costCentre)})`}
                    </b>
                </Text>
            </div>
        </div>
    );
};

export default WeeklyHoursAction;
